module.exports = __webpack_public_path__ + "img/logo1 (7).ff5e373d.jpg";